export default defineNuxtRouteMiddleware(async (to) => {
  // const { user, initAuth } = useAuth()
  
  // 初始化认证状态
  // await initAuth()

  // 检查认证状态
  // if (!user.value && to.path !== '/auth/login' && to.path !== '/auth/register') {
  //   return navigateTo('/auth/login')
  // }

  // // 已登录用户访问登录/注册页面时重定向到仪表盘
  // if (user.value && (to.path === '/auth/login' || to.path === '/auth/register')) {
  //   return navigateTo('/dashboard')
  // }
})